/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import ProveedorEstado from '@infotrack/presentacion-componentes/proveedorEstado';
import React from 'react';
import FormularioFlujosEtapasCV from './controladorVista/formularioFlujosEtapasCV';
import TablaFlujosEtapasCV from './controladorVista/tablaFlujosEtapasCV';
import { estadoInicial, reductor } from './reductorFlujosEtapas';

const FlujosEtapas: React.FunctionComponent = () => (
    <ProveedorEstado estadoInicial={estadoInicial} reductor={reductor}>
        <TablaFlujosEtapasCV />
        <FormularioFlujosEtapasCV />
    </ProveedorEstado>
);

export default FlujosEtapas;
